import { render, staticRenderFns } from "./upOtherFile.vue?vue&type=template&id=ee286c8c&"
import script from "./upOtherFile.vue?vue&type=script&lang=js&"
export * from "./upOtherFile.vue?vue&type=script&lang=js&"
import style0 from "./upOtherFile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports